import React from 'react';

import { flagStyles } from '../settings';

const SvgME = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3312px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgME;
